import {OPEN_COOKIE_PREFERENCES_EVENT} from '../consts';

export function subscribeCookiePreferences(handler: () => void): () => void {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  window.addEventListener(OPEN_COOKIE_PREFERENCES_EVENT, handler);

  return () => {
    window.removeEventListener(OPEN_COOKIE_PREFERENCES_EVENT, handler);
  };
}
